import httpService from '../httpService';
import { Form } from '../../models/forms.model';
import { getSelectedCommunity } from '../../hooks/community/useSelectedCommunity';

// Note: mock implementations were removed. This service always calls the real API.

async function list(): Promise<Form[]> {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) return [];

  const { data } = await httpService.get<Form[]>(`/networks/communities/${communityId}/forms`);
  return data;
}

async function create(body: unknown): Promise<Form> {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) throw new Error('No selected community');

  const { data } = await httpService.post<Form>(`/networks/communities/${communityId}/forms`, body);
  return data;
}

async function get(formId: string): Promise<Form> {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) throw new Error('No selected community');

  const { data } = await httpService.get<Form>(`/networks/communities/${communityId}/forms/${formId}`);
  return data;
}

async function submit(formId: string, payload: { userId: number; answers: { questionId: string; response: string }[] }, user?: any) {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) throw new Error('No selected community');

  const { data } = await httpService.post(`/networks/communities/${communityId}/forms/${formId}/responses`, payload);
  return data;
}

async function responses(formId: string) {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) throw new Error('No selected community');

  const { data } = await httpService.get(`/networks/communities/${communityId}/forms/${formId}/responses`);
  return data;
}

async function remove(formId: string) {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) throw new Error('No selected community');

  const { data } = await httpService.delete(`/networks/communities/${communityId}/forms/${formId}`);
  return data;
}

async function update(formId: string, body: any) {
  const communityId = getSelectedCommunity()?.id;
  if (!communityId) throw new Error('No selected community');

  const { data } = await httpService.put(`/networks/communities/${communityId}/forms/${formId}`, body);
  return data;
}

export default { list, create, get, submit, responses, remove, update };
